import React, { ChangeEvent, Dispatch, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, TextField, Typography } from '@material-ui/core';

import { Network, SharesItemFragment } from 'api';
import { CustomSVG, ICustomSVG } from 'components';
import { useSocialConnections } from 'hooks';
import { getSocialAccount } from 'features/activity/helpers';
import { TextCounter } from 'features/posting';
import { getCommentCharLimit } from 'features/posting/helpers';

interface IProps {
  shareItem: SharesItemFragment;
  setEditShare: Dispatch<Partial<SharesItemFragment>>;
  getEditShare: Partial<SharesItemFragment>;
}

const useStyles = makeStyles(theme => ({
  twitter: {
    color: theme.custom.networks.twitter,
  },
  linkedin: {
    color: theme.custom.networks.linkedin,
  },
  textArea: {
    '& > div': {
      display: 'block',
    },
  },
}));

const CommentSection: FC<IProps> = ({ shareItem, setEditShare, getEditShare }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { connections } = useSocialConnections();
  const { network, content } = shareItem;

  function handleCommentChange(event: ChangeEvent<HTMLInputElement>) {
    setEditShare({ ...getEditShare, user_commentary: event.target.value });
  }

  return (
    <Grid item xs>
      <Grid container direction="column">
        <Grid item>
          <Grid container spacing={1}>
            <Grid item>
              <CustomSVG classes={{ root: classes[network] }} name={network as keyof ICustomSVG} />
            </Grid>
            <Grid item>
              <Typography variant="h6">{getSocialAccount(shareItem, connections)}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <TextField
            classes={{ root: classes.textArea }}
            name="user_commentary"
            placeholder={t(`sharing:${network}`)}
            fullWidth
            multiline
            rows="19"
            value={getEditShare.user_commentary}
            onChange={handleCommentChange}
            InputProps={{
              endAdornment: (
                <TextCounter
                  length={getEditShare.user_commentary.length}
                  limit={getCommentCharLimit(network as Network, content)}
                />
              ),
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CommentSection;
